export default "__VITE_ASSET__BKwbQpr8__"